const list = ['VetterVettingHistory'];
const vettingParticipation = ['VetterVettingParticipation'];
const vettingCommitteeList = ['VetterVettingCommitteeList'];

export {
  list,
  vettingParticipation,
  vettingCommitteeList,
};
